import React from 'react';

import { useCompanyOverviewSectionQuery } from 'generated/graphql';



type IGlField = {
  label: string;
  value: string;
};

export interface IData {
  fields: IGlField[];
}

export function useQuery(listedCompanyId: string) {
  const tuple = useCompanyOverviewSectionQuery({
    variables: {
      listedCompanyId
    },
    skip: !listedCompanyId
  });

  return React.useMemo(
    () => {
      const data: IData = {
        fields: [{
          value: '',
          label: tuple.data?.listedCompany?.description ?? ''
        }]
      };
      return {
        ...tuple,
        data
      };
    },
    [tuple]



  );
}
